// extracted by mini-css-extract-plugin
module.exports = {"root":"_11gHK","loading":"_1nr5o","preloader":"_1fiKf","semi-rotate":"_1vrB2","semiRotate":"_1vrB2","inner-rotate":"mbnqu","innerRotate":"mbnqu"};